import React from 'react'
import { PropsWithChildren } from 'react'

import s from './styles.module.scss'

interface GoogleRatingLinkProps extends PropsWithChildren {
  placeId: string
}
export const GoogleRatingLink = ({
  placeId,
  children,
}: GoogleRatingLinkProps) => {
  return (
    <a
      href={`https://www.google.com/maps/place/?q=place_id:${placeId}`}
      target='_blank'
      rel='noreferrer'
      className={s.link}
    >
      {children}
    </a>
  )
}
